<template>
  <v-list-item class="vertical-nav-menu-link" v-bind="$attrs" active-class="bg-gradient-primary white--text">
    <template v-slot:default="{ active }">
      <v-list-item-icon v-if="icon">
        <v-icon v-if="!isSvgIcon" size="24px">{{ icon }}</v-icon>
        <svg-icon v-else :iconClass="icon"></svg-icon>
      </v-list-item-icon>
      <v-list-item-title>
        {{ $t(title) }}
      </v-list-item-title>
      <v-list-item-icon v-if="active">
        <v-icon>{{ icons.mdiChevronRight }}</v-icon>
      </v-list-item-icon>
    </template>
  </v-list-item>
</template>

<script>
import { mdiChevronRight } from '@mdi/js'
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    isSvgIcon: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup() {
    return {
      icons: {
        mdiChevronRight,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.alternate-icon-small {
  font-size: 14px;
  height: 14px;
  width: 14px;
}

.vertical-nav-menu-link {
  &.v-list-item--active {
    box-shadow: 0 5px 10px -4px rgba(94, 86, 105, 0.42);
    @include elevationTransition();

    & > .v-list-item__title {
      font-weight: bold;
    }
  }
}
</style>
